<template>
<el-radio-group v-model="dimensionType" size="small" @change="onSelectChanged">
  <el-radio-button :label="0">单站房多因子</el-radio-button>
  <el-radio-button :label="1">多站房单因子</el-radio-button>
</el-radio-group>
</template>

<script>
export default {
  name: 'DimensionType',
  props: {
    defaultDimensionType: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      dimensionType: this.defaultDimensionType
    }
  },
  methods: {
    onSelectChanged (dimensionType) {
      this.$emit('update:defaultDimensionType', dimensionType)
      this.$emit('change', dimensionType)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/DimensionType.vue